export default "__VITE_ASSET__DaDwku3Y__"